import React from 'react';
import cn from 'clsx';

import Typography from '../typography/typography';

import { toInches } from '../../shared/utils/text/text';

import styles from './size-badge.scss';

interface SizeBadgeProps {
  className?: string;
  isOE?: boolean;
  sizeQualifier?: string;
}

function SizeBadge(props: SizeBadgeProps) {
  const { className = '', isOE = false, sizeQualifier } = props;
  return (
    <Typography
      className={cn(
        styles['size-badge'],
        'size-badge',
        className,
        isOE && styles['size-badge-oe'],
        isOE && 'size-badge--oe'
      )}
      size="small"
      tag="span"
      weight="black"
    >
      {isOE
        ? 'O.E.'
        : `${
            sizeQualifier?.length && parseInt(sizeQualifier) > -1 ? '+' : ''
          }${toInches(sizeQualifier)}`}
    </Typography>
  );
}

export default SizeBadge;
